import React from 'react';
// import logout from '../Components/Image/logout.png'
// import Sidebar from '../Components/Sidebar';
// import { Table, InputGroup, FormControl } from 'react-bootstrap';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// To make rows collapsible
import "bootstrap/js/src/collapse.js";
// import { useHistory,Link, Redirect } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchBar from '../Components/SearchBar';
import { connect } from 'react-redux'
import { getQATemplates } from '../store/actions/qaTemplateActions'
import {
    getPODetails, getPOSearch,
    // postPOLineItem,
    inspectionDashboard,
} from '../store/actions/poDetailsActions'
import { getDepartmentSearch } from '../store/actions/departmentActions'
import { getInspectionDetailsByInspectorID, getsupplierInspection } from '../store/actions/inspectionActions'
import AuthHandlerInstance from '../Classes/AuthHandler'
// import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import { CSVLink } from "react-csv";
import Loading from '../Components/Loader'
class SupplierInspection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Inspectiontabledata: [{ "item": "item1" }, { "item": "item2" }, { "item": "item3" }],
            multiCollapseIndex: '',
            array: [
                { value: 1, label: "element1" },
                { value: 2, label: "element2" },
                { value: 3, label: "element3" },
                { value: 4, label: "element4" }],
            csvData: [],
            loading: false,
            supplierInspection: []
        }
        this.togglebutton = this.togglebutton.bind(this);
    }

    togglebutton = (index) => {
        var multiCollapseIndex = this.state.multiCollapseIndex
        if (multiCollapseIndex !== index || multiCollapseIndex === '') {
            this.setState({ multiCollapseIndex: index })
        }
    }

    componentDidMount = async () => {
        await this.setState({ loading: true })
        var roles = AuthHandlerInstance.getRoles()
        var userId = AuthHandlerInstance.getUserID()
        var csvData = []
        if (roles[6]) {
            this.props.getsupplierInspection(userId)
        }
        await this.props.getsupplierInspection(userId)
        var supplierInspection = await this.props.inspectionReducer.supplierInspection
        await supplierInspection.map(async (element) => {
            await csvData.push({
                "Call No.": element.callNo,
                "Call Date": element.createdOn ? dateFormater(element.createdOn) : '---',
                "PO Number": element.poNo,
                "PO Item": element.poLineItemNo,
                "WBSCode": element.WBSCode,
                "Proposed Date": element.proposedDate ? dateFormater(element.proposedDate) : '---',
                "Status": element.InspectionCallStatus ? element.InspectionCallStatus : "Not Yet Started",
                "Offered Quantity": (element.OfferedQuantity ? element.OfferedQuantity : 0) + " " + element.Unit,
                "Accepted Quantity": (element.AcceptedQuantity ? element.OfferedQuantity : 0) + " " + element.Unit,
                "Pending Quantity": parseFloat(element.OfferedQuantity - element.AcceptedQuantity) + " " + element.Unit,
                "Rework Reoffer Quantity": (element.ReworkReofferQty ? element.ReworkReofferQty : 0) + " " + element.Unit,
                "Rejected Quantity": (element.RejectedQuantity ? element.RejectedQuantity : 0) + " " + element.Unit,
                "Supplier Not Ready Quantity": (element.SupplierNotReadyQty ? element.SupplierNotReadyQty : 0) + " " + element.Unit,
                "Rework Compliance Quantity": (element.ReworkComplainceQty ? element.ReworkComplainceQty : 0) + " " + element.Unit,
                "Inspection Not Completed": (element.InspectionNotCompletedQty ? element.InspectionNotCompletedQty : 0) + " " + element.Unit,
            })
        })
        await this.setState({ supplierInspection,csvData, loading: false })
    }

    render() {
        console.log(this.props.inspectionReducer, "user")

        return (
            this.state.loading ?
                <Loading />
                :
                <div className="Container-fluid p-4 " style={{ 'height': '100vh' }}>
                    <div className="Container-fluid " style={{ opacity: this.state.opacity }}>
                        <div className="row">
                            <div className="col-md-5 header">
                                <b>Inspection Dashboard</b>
                            </div>
                            <div className="col-md-2">
                                <CSVLink className="btn2 btn-sms1  rounded-pill float-right" data={this.state.csvData} filename='Supplier-Inspection' style={{ marginTop: 8 }}>export</CSVLink>
                            </div>
                            <div className="col-md-5 " style={{ paddingRight: 35 }}>
                                <SearchBar placeholder="Search" label="Search" btnName="" />
                            </div>
                        </div>

                        <div className="row  pl-2 pr-4">
                            <div className="col pr-4">
                                <div className="row headerbar" >
                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar">Call No.</div>
                                    <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Number</div>
                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar ">PO Item</div>
                                    <div className="col-md-3 pt-2 pb-2 borderheaderbar ">PO Date</div>
                                    <div className="col-md-2 pt-2 pb-2 borderheaderbar ">Status</div>
                                </div>

                                {this.state.supplierInspection.length > 0 ?
                                    this.state.supplierInspection.map((element, Index) =>
                                        <div>
                                            <div className={Index % 2 === 0 ? 'row border ' : 'row  background '}
                                                onClick={() => this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar">{element.callNo}</div>
                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar">{element.poNo}</div>
                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar ">{element.poLineItemNo}</div>
                                                <div className="col-md-3 pt-2 pb-2 borderheaderbar ">{dateFormater(element.createdOn)}</div>
                                                <div className="col-md-2 pt-2 pb-2 borderheaderbar ">{element.InspectionCallStatus ? element.InspectionCallStatus : "Not Yet Started"}</div>
                                            </div>

                                            <div className={Index === this.state.multiCollapseIndex ? `container collapse multi-collapse${Index}` : `container collapse`}>

                                                <div className="row">
                                                    <div className="col-md-3 ">
                                                        <b>Total PO Quantity :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.TotalQuantity + " " + element.Unit}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Assigned Inspector:</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.InspectorName}
                                                    </div>

                                                    <div className="col-md-3 ">
                                                        <b>Pending Quantity :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {(parseFloat(element.TotalQuantity) - parseFloat(element.OfferedQuantity)) + " " + element.Unit}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Item Description:</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.lineItemDescription}
                                                    </div>

                                                    <div className="col-md-3 ">
                                                        <b>Inspection Quantity : </b>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        {element.inspectionQuantity + " " + element.Unit}
                                                    </div>

                                                    <div className="col-md-3 ">
                                                        <b>Inspection Date:</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.InspectionStartDate ? dateFormater(element.InspectionStartDate) + ' to ' + dateFormater(element.InspectionEndDate) : 'NA'}
                                                    </div>

                                                    <div className="col-md-3 ">
                                                        <b>Accepted Quantity :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.AcceptedQuantity !== null ? element.AcceptedQuantity + " " + element.Unit : 0 + " " + element.Unit}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Rework Reoffer Quantity :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.ReworkReofferQty !== null ? element.ReworkReofferQty + " " + element.Unit : 0 + " " + element.Unit}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Rejected Quantity :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.RejectedQuantity !== null ? element.RejectedQuantity + " " + element.Unit : 0 + " " + element.Unit}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Supplier Not Ready Quantity :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.SupplierNotReadyQty !== null ? element.SupplierNotReadyQty + " " + element.Unit : 0 + " " + element.Unit}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Rework Compliance Quantity :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.ReworkComplainceQty !== null ? element.ReworkComplainceQty + " " + element.Unit : 0 + " " + element.Unit}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Inspection Not Completed :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.InspectionNotCompletedQty !== null ? element.InspectionNotCompletedQty + " " + element.Unit : 0 + " " + element.Unit}
                                                    </div>

                                                    <div className="col-md-3 ">
                                                        <b>Location :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.location}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Proposed date of Inspection :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {dateFormater(element.proposedDate)}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>PO Delivery Date :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {dateFormater(element.deliveryDate)}
                                                    </div>

                                                    <div className="col-md-3 ">
                                                        <b>Waived Off :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.HasWaivedOff ? 'Yes' : 'No'}
                                                    </div>


                                                    {/* <div className="col-md-3 ">
                                                            <b>Inspection Call Status :</b>
                                                        </div>
                                                        <div className="col-md-3">

                                                        {element.InspectionCallStatus? element.InspectionCallStatus:"Not Yet Started"}
                                                        </div>   */}
                                                    <div className="col-md-3 ">
                                                        <b>Inspection Comments :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.InspectionCallStatus !== null ? element.InspectionComments : "NA"}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Next Planned Date :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.NextPlannedDate && element.NextPlannedDate !== null ? dateFormater(element.NextPlannedDate) : "NA"}

                                                    </div>


                                                    <div className="col-md-3 ">
                                                        <b>PO Line Item Status :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.POLineItemstatus}
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <b>Requested Stage to Inspect :</b>
                                                    </div>
                                                    <div className="col-md-3">
                                                        {element.stages.map((stage) => stage.stageNameToInspect).join(", ")}
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    )
                                    : <span style={{display: 'flex',justifyContent: 'center'}}>No call record found</span>}
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

const mapStateToProps = (state) => ({ qaTemplate: state.qaTemplate, poDetails: state.poDetails, departmentSearch: state.departmentSearchReducer, inspectionReducer: state.inspectionReducer })
export default connect(mapStateToProps, { getQATemplates, getPODetails, getDepartmentSearch, getPOSearch, inspectionDashboard, getInspectionDetailsByInspectorID, getsupplierInspection })(SupplierInspection)
